import { Component, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { EmptyContainer, highlightEmpty } from './copyfinder';

/*
  The empty container table shared by Resource Test and Package Test: one row per container with no
  resources, found anywhere in a holder. Each row opens the holder's JSON beneath it, folded down to
  that container.
*/

interface ShownEmpty {
  row: EmptyContainer;
  key: string;
}

@Component({
  selector: 'app-empty-containers',
  templateUrl: './emptycontainers.component.html',
  styleUrls: ['./resourcetest.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class EmptyContainersComponent implements OnChanges {
  @Input() rows: EmptyContainer[] = [];

  shown: ShownEmpty[] = [];

  //Rows whose JSON is open, and the highlights for each, built when first opened
  opened = new Map<string, { notes: Map<string, string>, good: Set<string>, expand: Set<string> }>();

  ngOnChanges(): void {
    this.opened.clear();
    this.shown = this.rows.map(row => ({ row, key: row.holder.kind + '|' + row.holder.name + '|' + row.path }));
  }

  toggle(s: ShownEmpty) {
    if (this.opened.has(s.key))
      this.opened.delete(s.key);
    else
      this.opened.set(s.key, highlightEmpty(s.row));
  }

  trackKey(index: number, s: ShownEmpty) {
    return s.key;
  }
}
